// import React, {Component} from "react";
import { Tab, TabPanel, Tabs, TabList } from "react-web-tabs";
// import ReactDOM from "react-dom";
import {Link} from "react-router-dom";
import {Nav, Navbar, NavItem} from "react-bootstrap";
import config from 'react-global-configuration';
import "react-web-tabs/dist/react-web-tabs.css";
import React, {Component, useState} from 'react';
import axios from "axios";
import $ from 'jquery';
import {Button, Collapse, Input, Label, Modal, ModalBody, ModalFooter, Card, CardBody, CardText} from 'reactstrap';
import 'datatables.net';
import 'datatables.net-responsive';
import "../assets/css/datatables/datatables.min.css";
import {css} from '@emotion/core';
import {BeatLoader} from 'react-spinners';
import NotificationSystem from "react-notification-system";
import {style} from "variables/Variables.jsx";
import '../assets/css/react-confirm-alert/react-confirm-alert.css';
//import {confirmAlert} from 'react-confirm-alert';
import ReactTooltip from 'react-tooltip';
import jwt_decode from "jwt-decode";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import SimpleReactValidator from 'simple-react-validator';
import moment from 'moment';
import CommonNavbar, {navbar} from "./commonNavbar";


const override = css `
    display: block;
    margin: 0 auto;
    border-color: red;
`;


class  MerchantViewPromotion extends Component {

    constructor(props) {
        super(props);
        this.state = {
            activer: [],
            isEMI: [],
            isUpfront: [],
            zeroCost: [],
            _notificationSystem: null,
            mapField: false,
            maxTxnAmount: 10000,
            selectedBrandSubvention: 'Percent',
            selectedBankSubvention: 'NA',
            selectedMerchantSubvention: 'All_Level',
            selectedState: [],
            selectedCity: [],
            merchant_disabler: true,
            brand_subvention_list:{},
            bank_subvention_list: [],
            brand_subvention_value: {},
            bank_subvention_value: [],
            maximum_cashback: [],
            disabler_list: [true, true, true, true, true, true, true, true, true, true, true, true],
            mapField2: false,
            startDate: moment(new Date()).format('YYYY-MM-DD'),
            endDate: moment(new Date()).format('YYYY-MM-DD'),
            sku_showModel: false,
            sku_list: [],
            raw_display_data: [],
            state_display_data: [],
            city_display_data: [],
            merchant_display_data: [],
            chain_display_data: [],
            store_display_data: [],
            state_loaded: false,
            city_loaded: false,
            sku_monitor: 0,
            selectedMerchValues: [],
            selectedRefineSubvention: [],
            slicedMerchValues: [],
            the_bank_list: {},
            bank_name_list1: {},
            refineSearch: false,
            state_ida: '',
            city_ida: '',
            merchant_ida: '',
            chain_ida: '',
            refinerMerch: [false, false, false, false, false],
            valuera: null,
            mapField3: false,
            mapField0: false,
            brand_has_merchant: [],
            stepper: [false, true, true, true],
            current_tab: 'vertical-tab-one',
            campaign_name: '',
            campaign_desc: '',
            merchant_length: null,
            merchant_counter: 1,
            merchant_counter_array: [0],
            follower: false,
            scheme_id: 0,
            scheme_display_data: [],
            sku_display_data: [],
            campaign_display_data: [],
            scheme_active: 0,
            mapFieldCampaign: false,
            campaignConfirmationModel: false,
            campaignID: null,
            brand_user_id: 13,
            scheme_master_data: [],
            scheme_master_list: [],
            newConfirmationModel: false,
            merchant_master_data: [],
            activer7: [],
            merchant2_display_data: [],
            merchant_master_list: [],
            party_id_mapper: [],
            party_master_id: null,
            reason: null,
            campaignDeconfirmationModel: false,
            emiMenus:[]
            //redirect = false
        };
        this.myRef = React.createRef();
        this.myRef2 = React.createRef();
    }

    handleNotificationClick = (position, color, msg) => {
        var level;
        switch (color) {
            case 1:
                level = "success";
                break;
            case 2:
                level = "warning";
                break;
            case 3:
                level = "error";
                break;
            case 4:
                level = "info";
                break;
            default:
                break;
        }
        this.state._notificationSystem.addNotification({
            title: <span data-notify="icon" className="pe-7s-gift" />,
            message: (
                <div>
                    {msg}
                </div>
            ),
            level: level,
            position: position,
            autoDismiss: 5
        });
    };

    componentDidMount(){
        // await this.getPartyID();
        this._getCampaignData();
        this.setState({
            campaignID: this.props.match.params.id,
            _notificationSystem: this.refs.notificationSystem
        })
        // await this._findBrandUserID();
        // await this._refreshSku_Show_View();
        // //await this.brand_has_merchant_finder();
        // await this._getSchemeData();
        // await this._getSkuData();
        // await this._getCampaignData();
        // await this._getMerchantFileUploaded();
        // await this._getSchemeMappingUploaded();
        // await this._getSchemeDetails();
        // await this.getSchemeMasterDataView();
        // //await this.getMerchantMasterDataView();
        // await this._getMerchantDetails();


        //var _notificationSystem = this.refs.notificationSystem;
        this.validator = new SimpleReactValidator();
    }

    //get details of campaign/promotion metadata, get id so that we can get selected products, schemes and merchants of that campaign/promotion
    _getCampaignData(){
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        axios.get(config.get('API_URL') + '/brandemi/get_campaign_data',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params: {
                id: this.props.match.params.id,
            }
        }).then(response => {
            //console.log(response.data);
            console.log(response);
            response.data.map((values, index) => {
                if(index == 0){
                    this.setState({
                        party_master_id: values.party_master_id,
                        campaign_name: values.campaign_name,
                        campaign_desc: values.campaign_desc,
                        startDate: values.start_date,
                        endDate: values.end_date,
                        maxTxnAmount: values.max_cashback,
                        scheme_active: values.active,
                        reason: values.reason
                    })
                }
            })
            this.setState({
                campaign_display_data: response.data
            });
            console.log("DOne");
            this._refreshSku_Show_View();
            this.getMerchantMappingData();
            this._findBrandUserID();
            //await this.brand_has_merchant_finder();
            //this._getSchemeData();
            this._getSkuData();
            //this._getMerchantFileUploaded();
            //this._getSchemeMappingUploaded();
            this._getSchemeDetails();
            this.getSchemeMasterDataView();
            //await this.getMerchantMasterDataView();
            this._getMerchantDetails();
        });
    }

    //get the list of schemes uploaded by user
    getSchemeMasterDataView(){
        if ($.fn.DataTable.isDataTable('#brandSchemeMasterViewTable')) {
            $('#brandSchemeMasterViewTable').DataTable().destroy();
        }
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        axios.get(config.get('API_URL') + '/brandemi/get_schemes_master_data', {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params: {
                party_master_id: this.state.party_master_id
            }
        }).then(response => {
            console.log(response);
            response.data.map((value, index) => {
                let status = false;
                if(value.active_status===1) { status = true;}
                this.setState({
                    activer: {...this.state.activer, [index]:status }
                });
            });
            this.setState({
                scheme_master_data: response.data
            });
            $('#brandSchemeMasterViewTable').DataTable();
        });
        return null;
    }


    //get partyID of user
    getPartyID(){
        if ($.fn.DataTable.isDataTable('#party_showTable')) {
            $('#party_showTable').DataTable().destroy();
        }
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        axios.get(config.get('API_URL') + '/brandemi/get_party_id',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params: {
                user_id: decoded._id,
            }
        }).then(response => {
            console.log(response.data);
            this.setState({
                party_id_mapper: response.data
            });
            $('#party_showTable').DataTable();
            this.setState({
                loading: false,
                user_id: decoded._id
            });
        });
    }

    //get merchants configured in backend
    getMerchantMappingData(){
        if(this.state.party_master_id != null){
            if ($.fn.DataTable.isDataTable('#merchant_showTable')) {
                $('#merchant_showTable').DataTable().destroy();
            }
            const token = localStorage.usertoken;
            const decoded = jwt_decode(token);
            axios.get(config.get('API_URL') + '/brandemi/view_merchant_maintainer',{
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                },
                params: {
                    party_master_id: this.state.party_master_id
                }
            }).then(response => {
                console.log(response.data);
                this.setState({
                    merchant2_display_data: response.data
                });
                $('#merchant_showTable').DataTable();
                this.setState({
                    loading: false,
                    user_id: decoded._id
                });
            });
        }
    }

    // get selected schemes for that campaign
    _getSchemeDetails(){
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        axios.get(config.get('API_URL') + '/brandemi/get_scheme_details',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params: {
                id: this.props.match.params.id,
            }
        }).then(response => {
            //console.log(response.data);
            console.log(response);
            response.data.map((values, index) => {
                this.setState({
                    scheme_master_list: {...this.state.scheme_master_list, [values.scheme_id]: true}
                })
            })
            console.log("DOne");
        });
    }

    //get selected merchants for the campaign
    _getMerchantDetails(){
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        axios.get(config.get('API_URL') + '/brandemi/get_merchant_details',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params: {
                id: this.props.match.params.id,
            }
        }).then(response => {
            //console.log(response.data);
            console.log(response);
            response.data.map((values, index) => {
                this.setState({
                    merchant_master_list: {...this.state.merchant_master_list, [values.merchant_data_id]: true}
                })
            })
            console.log("DOne");
        });
    }

    //get selected products of campaign/promotion
    _getSkuData(){
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        axios.get(config.get('API_URL') + '/brandemi/get_scheme_sku_data',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params: {
                campaignID: this.props.match.params.id,
            }
        }).then(response => {
            console.log(response);
            response.data.map((values, index) => {
                this.setState({
                    sku_list: {...this.state.sku_list, [values.sku]:true}
                })
            })
            this.setState({
                sku_display_data: response.data
            });
            console.log("DOne");
        });
    }

    //get the user_id of the brand whcih uploaded the data
    _findBrandUserID(){
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        axios.get(config.get('API_URL') + '/brandemi/get_brand_user_id',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params: {
                id: this.props.match.params.id,
            }
        }).then(response => {
            //console.log(response.data);
            console.log(response);
            response.data.map((values, index) => {
                console.log(values.user_id);
                this.setState({
                    brand_user_id: values.user_id
                })
            })
            console.log("DOne");
        });
    }

    //get list of all possible products for brand
    _refreshSku_Show_View() {
        if ($.fn.DataTable.isDataTable('#sku_showTable')) {
            $('#sku_showTable').DataTable().destroy();
        }
        console.log(this.state.brand_user_id);
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        axios.get(config.get('API_URL') + '/brandemi/view_brand_sku',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params: {
                party_master_id: this.state.party_master_id,
            }
        }).then(response => {
            this.setState({
                raw_display_data: response.data
            });
            $('#sku_showTable').DataTable();
        });
    }


    handleFromChange = date => {
        this.setState({
            startDate: moment(date).format('YYYY-MM-DD'),
            mapField2: false
        });
    };

    handleToChange = date => {
        this.setState({
            endDate: moment(date).format('YYYY-MM-DD'),
            mapField2: false
        });
    };


    changeSKU = (sku, checked) => {
        let sku_monitor_incr = this.state.sku_monitor;
        if (checked === true){
            this.setState((state) => ({
                sku_monitor: state.sku_monitor + 1
            }))
        }
        else{
            this.setState((state) => ({
                sku_monitor: state.sku_monitor - 1
            }))
        }
        this.setState({
            sku_list: {...this.state.sku_list, [sku]:checked},
            mapField2: false,
            mapField: false
        });
    };

    skuMapping() {
        //console.log("hello world");
    }

    toggleConfirmationModel() {
        //if (this.state.sku_list.length == 0){
        if (this.state.sku_monitor === 0){
            this.handleNotificationClick("tr", 3, "Select atleast one SKU");
        }
        else{
            this.setState({
                newConfirmationModel: !this.state.newConfirmationModel
            });
        }
    }

    toggleCampaignModel() {
        this.setState({
            campaignConfirmationModel: !this.state.campaignConfirmationModel
        });
    }

    toggleDecampaignModel() {
        this.setState({
            campaignDeconfirmationModel: !this.state.campaignDeconfirmationModel
        });
    }

    openSectionToMap = (status) => {
        this.setState({
            mapField: status
        })
    };


    updateMapVisiblity = (value) => {
        //console.log(JSON.stringify(value));
        this.setState({
            mapField: value
        })
    };

    changeActiver(index, checked) {
        this.setState({
            activer: {...this.state.activer, [index]:checked.target.checked },
            mapField: false

        });
    }

    //activate campaign action is sent to backend
    sendActivateCampaign = () => {
        const data = new FormData();
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        data.append('scheme_id', this.state.campaignID);
        axios.post(config.get('API_URL') + '/brandemi/submit_campaign_activate', data, {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        }).then(res => {
            this.props.history.push('/admin/run-promotions')
        }).catch(err => {

        })

    }

    sendDeactivateCampaign = () => {
        if(this.state.reason != null){
            const data = new FormData();
            const token = localStorage.usertoken;
            const decoded = jwt_decode(token);
            data.append('scheme_id', this.state.campaignID);
            data.append('reason', this.state.reason);
            axios.post(config.get('API_URL') + '/brandemi/submit_campaign_deactivate', data, {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }
            }).then(res => {
                this.props.history.push('/admin/run-promotions')
            }).catch(err => {

            })
        }
        else{
            this.handleNotificationClick("tr", 3, "Reason field is empty");
        }
    }

    openActivateConfirmation = (status) => {
        this.setState({
            mapFieldCampaign: status,
            campaignConfirmationModel: !this.state.campaignConfirmationModel
        });
    }

    openDeactivateConfirmation = (status) => {
        this.setState({
            mapFieldCampaign: status,
            campaignDeconfirmationModel: !this.state.campaignDeconfirmationModel
        });
    }

    tabClicker(value){
        if(value == 1){
            this.setState({
                stepper: {...this.state.stepper, [1]: true},
                stepper: {...this.state.stepper, [2]: true},
                stepper: {...this.state.stepper, [3]: true}
            })
        }
    }

    render() {

        let menus = this.state.emiMenus.map((menu, index) =>{
            return (
                <NavItem key={index} eventKey={index + "_" + 5} componentClass={Link} href={menu.layout+menu.path } to={menu.layout+menu.path}>
                    {menu.name}
                </NavItem>
            )
        });

        console.log(this.state.merchant2_display_data);
        console.log(this.state.party_master_id);
        console.log(this.state.scheme_ac)

        let scheme_data_master = this.state.scheme_master_data.map((value, index) =>{
            let timer2 = new Date(value.record_update_timestamp)
            timer2.setHours( timer2.getHours() + 5 );
            timer2.setMinutes( timer2.getMinutes() + 30 );
            // timer
            let timer3 = timer2.toJSON().slice(0, 19).replace('T', ' ');
            let cashback_render = '';
            let brand_sub_render = value.brand_sub;
            let brand_sub_amount_render = value.brand_sub_amount;
            let tenure_render = value.tenure;
            if (value.is_emi == 0 || value.is_emi == '0'){
                tenure_render = 'NA';
            }
            if (value.is_cashback == 0 || value.is_cashback == '0'){
                cashback_render = 'No';
                brand_sub_render = 'NA';
                brand_sub_amount_render = 'NA';
            }
            else{
                cashback_render = 'Yes';
            }
            let max_cashback_render = value.max_cashback;
            if(max_cashback_render == -1 || max_cashback_render == '-1'){
                max_cashback_render = 'NA'
            }
            return (
                <tr key={index + 1}>
                    <td>{value.scheme_name}</td>
                    <td>{value.bank_name}</td>
                    <td>{(value.is_emi)? 'Y' : 'N'}</td>
                    <td>{tenure_render}</td>
                    <td>{cashback_render}</td>
                    <td>{brand_sub_render}</td>
                    <td>{brand_sub_amount_render}</td>
                    <td>{max_cashback_render}</td>
                    <td>{timer3}</td>
                    <td>{(this.state.scheme_master_list[value.id]) ? 'Yes' : 'No'}</td>
                </tr>
                )
        });

        let merchant_data_master = null;
        if(this.state.party_master_id != null && this.state.merchant2_display_data.length != 0){
            merchant_data_master = this.state.merchant2_display_data.map((value, index) =>{
                return (
                    <tr key={index + 1}>
                        <td>{value.merchant_id}</td>
                        <td>{value.merchant_name}</td>
                        <td>{value.merchant_code}</td>
                        <td>{value.chain_id}</td>
                        <td>{value.chain_name}</td>
                        <td>{value.chain_code}</td>
                        <td>{value.store_id}</td>
                        <td>{value.store_name}</td>
                        <td>{value.store_code}</td>
                        <td>{value.store_address}</td>
                        <td>{value.field_1}</td>
                        <td>{value.field_2}</td>
                        <td>{value.field_3}</td>
                        <td>{value.field_4}</td>
                        <td>{value.field_5}</td>
                        <td>{(this.state.merchant_master_list[value.id]) ? 'Yes' : 'No'}</td>
                    </tr>
                )
            });
        }

        console.log(this.state.raw_display_data)
        //console.log(this.state.endDate);

        //const { redirect } = this.state;
        let bank_activer = this.state.activer;
        let start_date = (this.state.startDate); //.toDateString();
        let end_date = new Date(this.state.endDate);
        end_date.setDate( end_date.getDate() - 1 ); //.toDateString();
        let end_date2 = end_date;
        let max_txn = this.state.maxTxnAmount;

        let sku_show_data = this.state.raw_display_data.map((value,index) => {
            return (
                <tr key={index + 1}>
                    <td>{value.brand}</td>
                    <td>{value.category}</td>
                    <td>{value.level_1}</td>
                    <td>{value.level_2}</td>
                    <td>{value.level_3}</td>
                    <td>{value.level_4}</td>
                    <td>{value.sku}</td>
                    <td>{value.product_code}</td>
                    <td>{value.mrp}</td>
                    <td>{value.mop}</td>
                    <td>{(this.state.sku_list[value.sku]) ? 'Yes' : 'No'}</td>
                </tr>
            );
        });

        let variabler = this.state.current_tab;
        let active_finder = '';
        let active_button_enabler = () =>{
            if (this.state.scheme_active == 0 || this.state.scheme_active == '0'){
                return (
                    <div className="row">
                        {/*<div className="col-md-12">*/}
                        {/*    <Button onClick={this.openActivateConfirmation.bind(this, true)} className="btn btn-primary pull-right">Activate Campaign</Button>{' '}*/}
                        {/*    <Button onClick={this.openDeactivateConfirmation.bind(this, true)} className="btn btn-primary pull-right">Deactivate Campaign</Button>*/}
                        {/*</div>*/}
                    </div>
                );
            }
            else{
                return(<div></div>);
            }
        }
        if (this.state.scheme_active == 1 || this.state.scheme_active == '1'){
            active_finder = ' - Active';
        }
        else if(this.state.scheme_active == 0 || this.state.scheme_active == '0'){
            active_finder = ' - Inactive';
        }
        else{
            active_finder = ' - Rejected';
        }
        let campaign_header = this.state.campaign_name + active_finder;

        let reason_giver = () => {
            if (this.state.scheme_active == -1 || this.state.scheme_active == '-1'){
                return(
                    <div className="row bottompaddingsubvention">
                        <div className=" col-sm-6 col-md-3 col-xs-12">
                            <Label>Rejection Reason</Label>
                            <Input id="reason" className="maxheighter" value={this.state.reason} onChange={(e)=> {
                                let {reason} = this.state;
                                reason = e.target.value;
                                if((e.target.value === '')){
                                    this.handleNotificationClick("tr", 3, "Insert valid reason");
                                }
                                this.setState({
                                    reason: reason,
                                    mapField2: false
                                })
                            }}/>
                        </div>
                    </div>
                )
            }
            else{
                return(
                    <div></div>
                )
            }
        }

        return(
            <div className="content">
                <CommonNavbar/>
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12 p-t-5">
                            <div className="card">
                                <div className="header">
                                    <h4 className="title">{campaign_header}
                                    </h4>
                                </div>
                                <div className="content">
                                    {/* defaultTab="vertical-tab-two" */}
                                    <Tabs defaultTab={variabler} vertical className="vertical-tabs">
                                        <TabList>
                                            <Tab className="tab-title" tabFor="vertical-tab-one" onClick={this.tabClicker.bind(this, 1)}>
                                                <h4 className='title'>Products</h4>
                                                <span className='text-muted'>
                                                    Selected products
                                                </span>
                                            </Tab>
                                            <Tab className="tab-title" tabFor="vertical-tab-two" onClick={this.tabClicker.bind(this, 2)}>
                                                <h4 className='title'> Schemes</h4>
                                                <span className='text-muted'>
                                                    Selected schemes
                                                </span>
                                            </Tab>
                                            {/*<Tab tabFor="vertical-tab-three" onClick={this.tabClicker.bind(this, 3)}>*/}
                                            {/*    <h4 className='title'>  Merchants</h4>*/}
                                            {/*    <span className='text-muted'>*/}
                                            {/*        Selected merchants*/}
                                            {/*    </span>*/}
                                            {/*</Tab>*/}
                                            <Tab className="tab-title" tabFor="vertical-tab-four" onClick={this.tabClicker.bind(this, 4)}>
                                                <h4 className='title'>  Details</h4>
                                                <span className='text-muted'>
                                                    Configured details
                                                </span>
                                            </Tab>
                                        </TabList>
                                        <TabPanel tabId="vertical-tab-one">
                                            {/* <Collapse isOpen={this.state.mapField0}> */}
                                            <div className="card-query-builder" >
                                                <NotificationSystem ref="notificationSystem" style={style} />
                                                <ReactTooltip />
                                                <div className="col-md-12">
                                                    <div className="card noshadow" ref={this.myRef2}>
                                                        <div className="header header-promotion">
                                                            <h4 className="title">Products</h4>
                                                            <span className='text-muted'>Selected products/SKUs are part of this promotion</span>
                                                        </div>
                                                        
                                                        <Modal className="modalsmall" isOpen={this.state.campaignConfirmationModel}
                                                               toggle={this.toggleCampaignModel.bind(this)}
                                                               size = "sm"
                                                        >
                                                            <ModalBody>
                                                                <div className="modalrow">
                                                                    <div className="col-xs-12 ">
                                                                        Are you sure?
                                                                    </div>
                                                                </div>
                                                                <div className="modalrow">
                                                                    <div className="col-md-12">
                                                                        <Button color="primary" onClick={this.sendActivateCampaign}>Activate Campaign</Button>{' '}
                                                                        <Button color="secondary" onClick={this.toggleCampaignModel.bind(this)}>Cancel</Button>
                                                                    </div>
                                                                </div>
                                                            </ModalBody>
                                                        </Modal>
                                                        <Modal className="modalsmall" isOpen={this.state.campaignDeconfirmationModel}
                                                               toggle={this.toggleDecampaignModel.bind(this)}
                                                               size = "sm"
                                                        >
                                                            <ModalBody>
                                                                <div className="modalrow">
                                                                    <div className="col-xs-12 ">
                                                                        Are you sure you want to reject this promotion?
                                                                    </div>
                                                                </div>
                                                                <div className="modalrow">
                                                                    <div className=" col-sm-6 col-md-3 col-xs-12">
                                                                        <Label>Enter Reason:</Label>
                                                                        <Input id="reason" className="maxheighter" value={this.state.reason} onChange={(e)=> {
                                                                            let {reason} = this.state;
                                                                            reason = e.target.value;
                                                                            if((e.target.value === '')){
                                                                                this.handleNotificationClick("tr", 3, "Insert valid reason");
                                                                            }
                                                                            this.setState({
                                                                                reason: reason
                                                                            })
                                                                        }}/>
                                                                    </div>
                                                                </div>
                                                                <div className="modalrow">
                                                                    <div className="col-md-12">
                                                                        <Button color="primary" onClick={this.sendDeactivateCampaign}>Deactivate Campaign</Button>{' '}
                                                                        <Button color="secondary" onClick={this.toggleDecampaignModel.bind(this)}>Cancel</Button>
                                                                    </div>
                                                                </div>
                                                            </ModalBody>
                                                        </Modal>
                                                        <div className='sweet-loading'>
                                                            <BeatLoader
                                                                css={override}
                                                                sizeUnit={"px"}
                                                                size={20}
                                                                color={'#123abc'}
                                                                loading={this.state.loading}
                                                            />
                                                        </div>
                                                        <div className="content table-full-width table-responsive">
                                                            <div className="row m-0">
                                                                <div className="col-md-12">
                                                                    <table className="table table-striped table-hover" id="sku_showTable">
                                                                        <thead>
                                                                        <tr>
                                                                            <th>Brand</th>
                                                                            <th>Category</th>
                                                                            <th>Level 1</th>
                                                                            <th>Level 2</th>
                                                                            <th>Level 3</th>
                                                                            <th>Level 4</th>
                                                                            <th>SKU</th>
                                                                            <th>Product Code</th>
                                                                            <th>MRP</th>
                                                                            <th>MOP</th>
                                                                            <th>Selected?</th>
                                                                        </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                        {sku_show_data}
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                                <div className="col-md-12">
                                                                    {/* <button onClick={this.openSectionToBanks.bind(this, true)} className="btn btn-primary">Choose Offers</button> */}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            {/* </Collapse> */}
                                        </TabPanel>
                                        <TabPanel tabId="vertical-tab-two">
                                            <div className="card-query-builder">
                                                <div className="col-md-12">
                                                    <div className="card noshadow" ref={this.myRef2}>
                                                        <div className="header header-promotion">
                                                            <h4 className="title">Schemes</h4>
                                                            <span className="text-muted">Selected schemes are part of this promotion</span>
                                                        </div>
                                                        
                                                        <div className="content table-full-width table-responsive">
                                                            <table className="table table-striped table-hover" id="brandSchemeMasterViewTable">
                                                                <thead>
                                                                <tr>
                                                                    <th>Scheme Name</th>
                                                                    <th>Bank Name</th>
                                                                    <th>Is Zero Cost EMI?</th>
                                                                    <th>Tenure</th>
                                                                    <th>Avail Cashback?</th>
                                                                    <th>Brand Sub</th>
                                                                    <th>Brand Sub Amount</th>
                                                                    <th>Max Cash back</th>
                                                                    <th>Time stamp</th>
                                                                    <th>Selected?</th>
                                                                </tr>
                                                                </thead>
                                                                <tbody>
                                                                {scheme_data_master}
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                        <div className="row">
                                                            {/* <div className ="col-md-12">
                                                                <button onClick={this.sendEMIMappings.bind(this, true)} className="btn btn-primary pull-right btn-capitalize">Choose Schemes</button>
                                                            </div> */}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </TabPanel>
                                        {/*<TabPanel tabId="vertical-tab-three">*/}
                                        {/*    <div className="col-md-12">*/}

                                        {/*        <div className="card">*/}

                                        {/*            <div className="row">*/}
                                        {/*                <div className="col-md-12 pt-5">*/}
                                        {/*                    <div className="header">*/}
                                        {/*                        <h4 className="title">Merchants</h4>*/}
                                        {/*                        <span className="text-muted">Please select merchants from below list</span>*/}
                                        {/*                    </div>*/}
                                        {/*                    <hr/>*/}
                                        {/*                    <div className="content table-full-width table-responsive">*/}
                                        {/*                        <table className="table table-striped table-hover" id="merchant_showTable">*/}
                                        {/*                            <thead>*/}
                                        {/*                            <tr>*/}
                                        {/*                                <th>Merchant ID</th>*/}
                                        {/*                                <th>Merchant Name</th>*/}
                                        {/*                                <th>Merchant Code</th>*/}
                                        {/*                                <th>Chain ID</th>*/}
                                        {/*                                <th>Chain Name</th>*/}
                                        {/*                                <th>Chain Code</th>*/}
                                        {/*                                <th>Store ID</th>*/}
                                        {/*                                <th>Store Name</th>*/}
                                        {/*                                <th>Store Code</th>*/}
                                        {/*                                <th>Store Address</th>*/}
                                        {/*                                <th>Field 1</th>*/}
                                        {/*                                <th>Field 2</th>*/}
                                        {/*                                <th>Field 3</th>*/}
                                        {/*                                <th>Field 4</th>*/}
                                        {/*                                <th>Field 5</th>*/}
                                        {/*                                <th>Selected?</th>*/}
                                        {/*                            </tr>*/}
                                        {/*                            </thead>*/}
                                        {/*                            <tbody>*/}
                                        {/*                            {merchant_data_master}*/}
                                        {/*                            </tbody>*/}
                                        {/*                        </table>*/}
                                        {/*                    </div>*/}
                                        {/*                </div>*/}
                                        {/*            </div>*/}
                                        {/*            <div className="footer">*/}
                                        {/*                <div className="stats"><i></i>*/}
                                        {/*                </div>*/}
                                        {/*            </div>*/}
                                        {/*        </div>*/}
                                        {/*    </div>*/}
                                        {/*</TabPanel>*/}
                                        <TabPanel tabId="vertical-tab-four">
                                            <div className="card-query-builder subvention-brand ">
                                                <div className="col-md-12">
                                                    <div className="card noshadow" ref={this.myRef}>
                                                        <div className="header header-promotion">
                                                            <h4 className="title">Promotion Details</h4>
                                                            <span className="text-muted">The following are the promotion details</span>
                                                        </div>
                                                        
                                                        <div className= "content">
                                                            <div className="row bottompaddingsubvention">
                                                                <div className=" col-sm-6 col-md-3 col-xs-12">
                                                                    <Label>Promotion Name</Label>
                                                                    <Input id="campaign_name" className="maxheighter" value={this.state.campaign_name} onChange={(e)=> {
                                                                        let {campaign_name} = this.state;
                                                                        campaign_name = e.target.value;
                                                                        if((e.target.value === '')){
                                                                            this.handleNotificationClick("tr", 3, "Insert campaign name");
                                                                        }
                                                                        this.setState({
                                                                            campaign_name: campaign_name,
                                                                            mapField2: false
                                                                        })
                                                                    }}/>
                                                                </div>
                                                                <div className=" col-sm-12 col-md-6 col-xs-12">
                                                                    <Label>Promotion Description</Label>
                                                                    <Input id="campaign_desc" className="maxheighter" value={this.state.campaign_desc} onChange={(e)=> {
                                                                        let {campaign_desc} = this.state;
                                                                        campaign_desc = e.target.value;
                                                                        if((e.target.value === '')){
                                                                            this.handleNotificationClick("tr", 3, "Insert campaign description");
                                                                        }
                                                                        this.setState({
                                                                            campaign_desc: campaign_desc,
                                                                            mapField2: false
                                                                        })
                                                                    }}/>
                                                                </div>
                                                            </div>

                                                            <div className="row bottompaddingsubvention">
                                                                <div className=" col-sm-6 col-md-3 col-xs-12">
                                                                    <Label>Select start date</Label>
                                                                    <DatePicker
                                                                        dateFormat="dd-MM-yyyy"
                                                                        selected={Date.parse(this.state.startDate)}
                                                                        onChange={this.handleFromChange}
                                                                    />
                                                                </div>
                                                                <div className="col-sm-6 col-md-3 col-xs-12">
                                                                    <Label>Select end date</Label>
                                                                    <DatePicker
                                                                        dateFormat="dd-MM-yyyy"
                                                                        selected={Date.parse(end_date2)}
                                                                        onChange={this.handleToChange}
                                                                    />
                                                                </div>
                                                                <div className="col-sm-6 col-md-4    col-xs-12">
                                                                    <Label>Maximum cashback allowed per card</Label>
                                                                    <Input id="txn_value" className="maxheighter" value={this.state.maxTxnAmount} onChange={(e)=> {
                                                                        let {maxTxnAmount1} = this.state;
                                                                        maxTxnAmount1 = e.target.value;
                                                                        if(((e.target.value)*1) <= 0 || (e.target.value === '')){
                                                                            this.handleNotificationClick("tr", 3, "Insert value greater than 0");
                                                                        }
                                                                        this.setState({
                                                                            maxTxnAmount: maxTxnAmount1,
                                                                            mapField2: false
                                                                        })
                                                                    }}/>
                                                                </div>
                                                            </div>
                                                            {reason_giver()}
                                                            {/* <button onClick={this.openSectionToProduct.bind(this, true)} className="btn btn-primary">Save</button> */}
                                                            {active_button_enabler()}

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </TabPanel>
                                    </Tabs>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

}
export default MerchantViewPromotion;